import React from "react";
import './work-section.css';

// ..... images .......
import step1 from '../../../assets/images/step-1.svg';
import step2 from '../../../assets/images/step-2.svg';
import step3 from '../../../assets/images/step-3.svg';

function WorkSection() {
   return(
       <div className="content-box width-1200">
          <div className="title-font">How it works?</div>
          <ul className="steps flex align-top hr-space-between rubik-medium">
             <li>
                <div className="step-title">Step 1</div>
                <div className="icon step-img">
                   <img src={step1} alt=""/>
                </div>
                <div className="step-desc">Capture the workflow</div>
             </li>
             <li>
                <div className="step-title">Step 2</div>
                <div className="icon step-img">
                   <img src={step2} alt=""/>
                </div>
                <div className="step-desc">Tada!! Your clickable product<br/> tour is created!</div>
             </li>
             <li>
                <div className="step-title">Step 3</div>
                <div className="icon step-img">
                   <img src={step3} alt=""/>
                </div>
                <div className="step-desc">Share/Embed anywhere</div>
             </li>
          </ul>
       </div>
   )
}

export default WorkSection;
